const mega_menu = {
    init: () => {
        $('body').on('click', '.js-mega-menu-slider-next', function (e) {
            e.preventDefault();
            const parent = $(e.target).parents('.js-mega-menu-slider');

            const els = parent.find('.mega-menu__block');
            let doScroll = true;
            let indexEl = 0;
            els.each(function () {
                if (($(this).offset().left - parent.offset().left) > 0 && doScroll == true) {
                    doScroll = false;
                }
                if (doScroll == true) {
                    indexEl += 1;
                }
            });
            parent.animate({
                scrollLeft: indexEl * 197
            }, 'slow');
        });
        $('.js-mega-menu-slider').on('scroll', function () {
            var newScrollLeft = $(this).scrollLeft(),
                width = $(this).outerWidth(),
                scrollWidth = $(this).get(0).scrollWidth;
            if (scrollWidth - newScrollLeft == width) {
                $(this).addClass('is-end');
            } else {
                $(this).removeClass('is-end');
            }
        })

        function checkArrow() {
            $('.js-mega-menu-slider').each(function () {
                var newScrollLeft = $(this).scrollLeft(),
                    width = $(this).outerWidth(),
                    scrollWidth = $(this).get(0).scrollWidth;
                if ( Math.round(scrollWidth - newScrollLeft) == Math.round(width)) {
                    $(this).addClass('is-end');
                } else {
                    $(this).removeClass('is-end');
                }
            })
        }

        checkArrow();
        $(window).on('resize', function () {
            checkArrow();
        })
    }
};
export default mega_menu;
